export default __webpack_public_path__ + "static/media/green_check.4d17baf7.svg";